module.exports = __webpack_public_path__ + "static/014.thumb-53a18c7e553791bb87f13cdf62cdee29.jpg";